import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import { removeProduct, setCar, setMinus } from "../services/actions";
import { useDispatch, useSelector } from "react-redux";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../theme";

import { Container, Grid, Paper, Divider } from "@material-ui/core";
import { test_ip } from "../services/constants";
import AlertDialogSlide from "../components/Dialog";

function Basket(props) {
  const [cart, setCart] = useState([]);
  const [success, setSuccess] = useState(false);
  const [total, setTotal] = useState(0);

  const nav = useNavigate();
  let products = props.cart;
  let new_products = useSelector((state) => state.cart);
  var cart_product = [];
  var user = JSON.parse(localStorage.getItem("user"));
  var lat = localStorage.getItem("lat");
  var lon = localStorage.getItem("lon");
  var store_id = localStorage.getItem("store_id");
  const diapch = useDispatch();

  // const [price,setPrice] = useState(.price)

  var req_data = {
    user_id: user.user_id,
    items: cart_product,
    server_token: user.server_token,
    destination_address: {
      name: "sdfgh",
      long: lon,
      lat: lat,
      note: null,
    },
    store_id: store_id,
    store_location: { lat: 9.001634799999998, long: 38.7796207 },
    is_schedule: false,
    schedule_start: null,
    delivery_for_other: false,
    username: "",
    phone: "",
  };

  var addQuant = (id) => {
    // var dd = cart
    // cart.forEach((proud) => {
    //   console.log(proud, 'in plus')
    //   if (proud._id == id) {
    //     proud.quantity += 1
    //   }
    // })
    // setCart([...dd])
    diapch(setCar(id));
  };
  var minuQuant = (id) => {
    // var dd = new_products
    // dd.forEach((proud) => {
    //   console.log(proud, 'in minus')
    //   if (proud._id == id) {
    //     if (proud.quantity == 1) {
    //       return
    //     }
    //     proud.quantity -= 1
    //   }
    // })
    // console.log(dd, 'in2222222222222222222222222222222 minus')
    // setCart([...dd])
    diapch(setMinus(id));
  };
  // useEffect(() => {
  //   var temp = []
  //   products.forEach((product) => {
  //     console.log('mapping', product)
  //     temp.push({
  //       _id: product._id,
  //       quantity: product.quantity,
  //       specifications: product.specifications,
  //       price: product.price,
  //       note_for_item: '',
  //       item_name: product.name,
  //       image_url: product.image_url,
  //     })
  //     setCart(temp)
  //   })
  // }, [])

  const add = function () {
    console.log("data", req_data);
    var temp = [];
    new_products.forEach((product) => {
      console.log("mapping", product);
      temp.push({
        _id: product._id,
        quantity: product.quantity,
        specifications: product.specifications,
        price: product.price,
        note_for_item: "",
        item_name: product.name,
        image_url: product.image_url,
      });
      // setCart(temp)
    });

    req_data.items = temp;
    console.log("data", req_data);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    nav("/locations", {
      state: {
        req_data: req_data,
      },
    });
    // Add_Item_to_Cart(req_data)
  };
  var Add_Item_to_Cart = function (data) {
    // call this only if store_count == 1
    var body = data;
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/user/add_item_in_cart_new`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          if (res.data.success == true) {
            var cart_id = res.data.cart_id; // you would get more data but this is the most important
            localStorage.setItem("cart_id", cart_id);
            console.log("ooryeyeyeyyeye 1");
            var another_req_object = {
              cart_id: cart_id,
              store_id: store_id,
              total_time: 317,
              total_distance: 2523,
              order_type: 7,
              is_user_pick_up_order: false,
              total_item_count: cart.length,
              is_user_drop_order: true,
              express_option: "normal",
              server_token: user.server_token,
            };
            console.log(another_req_object);
            Get_order_cart_invoice(another_req_object);
          } else {
            console.log(res.data.error_code);
          }
        } else {
          // do something
        }
      })
      .catch((err) => {
        // do something
      });
  };
  var Get_order_cart_invoice = function (data) {
    // call this only if store_count == 1
    var body = data;
    body = JSON.stringify(body);
    axios
      .post("http://196.189.44.49:7000/api/user/get_order_cart_invoice", body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          console.log("ooryeyeyeyyeye 2");
          if (res.data.success == true) {
            var order_payment = res.data.order_payment; // you would get more data but this is the most important
            var vehicles = res.data.vehicles; // get vehicle list
            console.log(vehicles);
            console.log(order_payment);
            // setSuccess(`successfully on ${vehicles[0].vehicle_name}`)
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
            nav(`/payment/${order_payment.unique_id}`, {
              state: { order: order_payment, vehicles: vehicles },
            });

            // setCart([])
          } else {
            console.log(res.data.error_code);
          }
        } else {
          // do something
        }
      })
      .catch((err) => {
        // do something
      });
  };
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: "white",
        width: "100vw", // Full width of the viewport
        height: "100vh",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          marginTop: "5px",
          marginBottom: "5px",
          fontSize: "0.8rem",
          width: "100%",
        }}
      >
        <h3 style={{ fontSize: "1.2rem", paddingLeft: "8px" }}>Cart</h3>
        {/* <div style={{ fontSize: '0.7rem', paddingLeft: '8px', marginBottom:'10px' }}>displaying {new_products.length} products in your basket(remeber only products of the same store
          can be in a basket at one time)</div> */}
      </div>
      <ThemeProvider theme={theme}>
        <CartCar
          cart_products={new_products}
          handleCart={props.handleCart}
          addQuant={addQuant}
          minuQuant={minuQuant}
        />
        {new_products.length == 0 ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
              marginBottom: "5px",
            }}
          >
            Empty,please select products
          </div>
        ) : (
          <Button
            style={{ marginTop: "8px", borderRadius: "10px" }}
            variant="contained"
            color="neutral"
            onClick={() => {
              add();
            }}
          >
            Checkout
          </Button>
        )}
      </ThemeProvider>
    </div>
  );
}

export default Basket;

function CartCar(props) {
  const [success, setSuccess] = useState(false);
  console.log(props, "hii cartcar");
  const diapch = useDispatch();
  const add = function (id) {
    props.addQuant(id);
  };
  const minu = function (id) {
    props.minuQuant(id);
  };
  const compute_price = (sp) => {
    var price = sp.price;
    for (let j = 0; j < sp.specifications.length; j++) {
      // price +=spec_items[i].list.price
      for (let i = 0; i < sp.specifications[j].list.length; i++) {
        price += sp.specifications[j].list[i].price;
        console.log("looping at ", i, j, price);
      }
    }
    return price;
  };
  const dialogue_data = {
    no: "No",
    yes: "Yes",
    primary: "Remove Product",
    // secondary: ''
    secondary: "this action will remove this product from your current basket.",
  };
  return (
    <Container style={{ backgroundColor: "white", padding: "5px" }}>
      <Grid container>
        {props.cart_products.map((item) => (
          <Grid item key={item._id} style={{ width: "100%" }}>
            <div>
              <CardContent style={{ padding: "5px" }}>
                <Typography
                  gutterBottom
                  variant="h1"
                  color="#000"
                  component="div"
                  style={{ fontSize: "1.1rem", margin: "0px" }}
                >
                  {item.name}
                </Typography>
                {/* <Typography variant="body2" color="text.secondary" style={{ fontSize: '0.8rem' }}>
                Price: {item.price}
              </Typography> */}
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    style={{
                      fonstSize: "0.8rem",
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "bold",
                    }}
                  >
                    Total Price: {item.quantity * compute_price(item)} Br.
                  </Typography>
                  <CardActions style={{ padding: "0px" }}>
                    <Button
                      onClick={() => {
                        minu(item._id);
                      }}
                    >
                      <RemoveIcon
                        size="small"
                        style={{ width: "15px" }}
                        color="neutral"
                      >
                        -
                      </RemoveIcon>
                    </Button>
                    <div style={{ fonstSize: "0.8rem" }}>{item.quantity}</div>
                    <Button
                      onClick={() => {
                        add(item._id);
                      }}
                    >
                      <AddIcon
                        size="small"
                        style={{ width: "15px" }}
                        color="neutral"
                      >
                        +
                      </AddIcon>
                    </Button>
                  </CardActions>
                </div>
                <div style={{ justifyContent: "end", display: "flex" }}>
                  {/* <Button size='small' onClick={()=>{diapch(removeProduct(item))}}> */}
                  <Button
                    size="small"
                    onClick={() => {
                      setSuccess(true);
                    }}
                  >
                    <DeleteForeverIcon color="neutral" />
                  </Button>
                  <AlertDialogSlide
                    open={success}
                    data={dialogue_data}
                    confirm={() => {
                      diapch(removeProduct(item));
                      console.log("shittt", item);
                      setSuccess(false);
                    }}
                    not={() => {
                      setSuccess(false);
                    }}
                  />
                </div>

                {/* {!item.specification.length == 0?  
                              <Typography variant="body2" color="text.secondary" style={{fontSize:'0.7rem'}}>
                              Specififcation: {item.specification.map((spec)=>(
                                 <>
                                 
                                 {spec.list.map((i)=>(
                                   <div style={{marginLeft:'8px'}}><Typography gutterBottom variant="h5" component="div" style={{fontSize:'0.6rem'}}>{i.name}({i.price})</Typography>
                                   </div>
                                 ))}
                                 </>
             
                             ))}
                           </Typography>: null} */}
                {/* <Typography style={{ fontSize: '0.9rem', textAlign: 'right', fontWeight: 'bold' }}>
                Total:  <span></span>{item.quantity * compute_price(item)} Br.
              </Typography> */}
              </CardContent>
            </div>
            {item ===
            props.cart_products[
              parseInt(props.cart_products.length) - 1
            ] ? null : (
              <Divider />
            )}
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
